// extracted by mini-css-extract-plugin
module.exports = {"cta-link":"HeaderCta_cta-link__KAlxw"};